import { IActivityHistoryCommonFilter } from "../../filter";
import { IActivityHistoryItem } from "../model";
import { Spec } from "./spec";
import { TrueSpec } from "./true-spec";

export class CommonFilterSpec extends Spec<IActivityHistoryItem> {
  constructor(private commonFilters: IActivityHistoryCommonFilter[]) {
    super();
  }

  isSatisfiedBy(item: IActivityHistoryItem): boolean {
    const enabledCommonFilters = this.commonFilters.filter((f) => f.enabled);
    const finalCommonSpec = enabledCommonFilters.reduce((acc, filter) => {
      return acc.and(new filter.spec());
    }, new TrueSpec());
    return finalCommonSpec.isSatisfiedBy(item);
  }
}
